// resources/js/utils/utils.js
import * as Config from '../router/config';
export function getChangedFields(original, edited) {
    let changedFields = [];
  
    Object.keys(edited).forEach(key => {
      if (edited[key] !== original[key]) {
        changedFields.push({
          field: key,
          old_value: original[key],
          new_value: edited[key]
        });
      }
    });
  
    return changedFields;
  }
  
 // determione whether the date is before or after 6th April
 export function isAprilSixthOrAfter() {
  const today = new Date();

  // check if today is 6th April or greater
  const isSixth = today.getDate() >= 6 && today.getMonth() >= 3;

  return isSixth;
 };

  // Determine what is the NI rate based on date.
  // on 6th Aprill the rate could be different than before 6th April
  export function determineNIrate() {
    const defaultNi = parseFloat(process.env.MIX_NI);
    const defaultNiNextYear = parseFloat(process.env.MIX_NI_NEXT_YEAR);

    if(isAprilSixthOrAfter()) {
      return defaultNiNextYear;
    }

    return defaultNi;
  }

  // Render taxation year
  export function renderTaxYear(next = false) {
    const today = new Date();
    let yearFrom = today.getFullYear() - 1;
    let yearTo = today.getFullYear();

    if(isAprilSixthOrAfter() || next) {
      yearFrom = today.getFullYear();
      yearTo = today.getFullYear() + 1;
    }

    return yearFrom + '/' + yearTo;
  }

  // Calculate pay rate
export function calculateRate(pay_amount, crm_type, order_type, margin = 0.00, admin_fee = 0.00, salary = 0.00, forceNiRate = 0.00) {
    const rate = calculateRateAsObject(pay_amount, crm_type, order_type, margin, admin_fee, salary, forceNiRate);

    return Number.parseFloat(rate.charge || 0).toFixed(2);
}

  // Calculate pay rate as object
  export function calculateRateAsObject(pay_amount, crm_type, order_type, margin = 0.00, admin_fee = 0.00, salary = 0.00, force_ni_rate = 0.00) {

    salary = Number.parseFloat(salary) || 0;
    force_ni_rate = Number.parseFloat(force_ni_rate) || 0;
    let charge = Number.parseFloat(pay_amount) || 0;
    let adminFee = Number.parseFloat(admin_fee) || 0;
    let holidayPercentage = Number.parseFloat(process.env.MIX_HOLIDAY_ACCRUAL / 100);
    let niPercentage = (force_ni_rate > 0.00 ? force_ni_rate : determineNIrate()) / 100;
    let pensionPercentage = Number.parseFloat(process.env.MIX_PENSION_STANDARD_PERC / 100);
    let marginPercentage = Number.parseFloat(margin / 100);
    let crmType = crm_type.toLowerCase();
    let orderType = order_type.toLowerCase();
    const rate = {
        ha: 0.00,
        haPercentage: holidayPercentage,
        ni: 0.00,
        niPercentage: niPercentage,
        pension: 0.00,
        pensionPercentage: pensionPercentage,
        marginPercentage: marginPercentage,
        charge: 0.00,
    };
        
    // rules for recruitment
    if(crmType === 'recruitment') {
  
      // do not apply rules for internal
      if(orderType === "internal") {
        rate.charge = 0.00;
        return rate;
      }

      // rule for permanent order
      if(orderType === "permanent") {
        rate.charge = salary * marginPercentage;
        return rate;
      }

      // rule for Payroll - Contract
        if (orderType === "payroll - contract") {
            rate.charge = adminFee;
            return rate;
        }

      // rule for other Contracts
      if (orderType.match(/(^|[-][ ])contract$/)) {
        rate.charge = charge / (1 - marginPercentage);
        return rate;
      }

    } else if(crmType === 'payroll') {
      // do not apply rules for internal and contracts
      if(orderType === "internal") {
        rate.charge = 0.00;
        return rate;
      }

      // rule for permanent order
      if(orderType === "permanent") {
        rate.charge = salary * marginPercentage;
        return rate;
      }

      // do not apply rules for internal and contracts
      if (orderType.match(/(^|[-][ ])contract$/)) {
        rate.charge = adminFee; //rewrite the same value
        return rate;
      }
    }
      
    // Calculate Holiday Accrual
    rate.ha = charge * holidayPercentage;
    charge += rate.ha;
    
    // Calculate National Insurane
    rate.ni = charge * niPercentage;
    charge += rate.ni;
    
    // Calculate Pension
    rate.pension = charge * pensionPercentage;
    charge += rate.pension;
    
    // Add Holiday, NI and Pension
    rate.charge = charge;
    
    // Add Margin
    if(marginPercentage > 0) {
      charge = charge / (1 - marginPercentage);
      rate.charge = charge;
    }

    // Return object
    return rate;
  }

export function lazyServerLogout(token, userId) {
    if (!token) return;

    const url = `${Config.apiPath}auth/logout`;
    const body = JSON.stringify({ user_id: userId || null });

    const run = () => {
        try {
            fetch(url, {
                method: 'POST',
                keepalive: true,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body,
                credentials: 'omit',
            }).catch(() => {});
        } catch (_) {}
    };

    if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(run, { timeout: 1500 });
    } else {
        setTimeout(run, 0);
    }
}